import { Trans } from "@lingui/macro"
import { FormLabel, Typography } from "@mui/material"
import { useFormikContext } from "formik"
import { FirstLoginFlowFormikProps } from "./index"
import { ResourcesDetailsButton } from "../resources/ResourcesDetailsCard/Button"
import { useState } from "react"
import { JobDialog } from "./JobDialog"
import { useDispatch } from "react-redux"
import { setUserData } from "app/redux/actions/UserActions"
import { useSelector } from "react-redux"
import { RootStateOrAny } from "react-redux"

export const OrganizationCreated = () => {

  const [displayJobDialog, setDisplayJobDialog] = useState(false)

  const dispatch = useDispatch()

  const user = useSelector((state: RootStateOrAny) => state.user)

  const { 
    values, handleChange, handleBlur, setFieldValue, validateForm, setFieldError
  } = useFormikContext<FirstLoginFlowFormikProps>()

  const onClickGoToHomepage = () => {
    setFieldValue('displayOrganizationCreatedWindow', false)
    dispatch(setUserData({
      ...user,
      contact: {
        ...user.contact,
        whatAreYouLookingFor: values.goal
      }
    }))
  }

  return (
    <>
      <JobDialog display={displayJobDialog} setDisplay={setDisplayJobDialog}/>

      <FormLabel sx={{ textAlign: 'center', fontSize: '24px', lineHeight: '28px', mb: '54px', mt: '-32px' }}>
        <Trans>FIRST_LOGIN_FLOW_CONNECT_TO_ORGANIZATION_LABEL</Trans>
      </FormLabel>

      <FormLabel sx={{ mb: '14px'}}>
        <Trans>FIRST_LOGIN_FLOW_FIND_YOUR_ORGANIZATION_HAS_BEEN_CREATED_LABEL</Trans>
      </FormLabel>

      <Typography variant="body2" sx={{ fontSize: '15px', lineHeight: '25px' }}>
        <Trans>FIRST_LOGIN_FLOW_MANAGER_OF_ORGANIZATION_TEXT</Trans>
      </Typography>

      <ResourcesDetailsButton
        text={<Trans>FIRST_LOGIN_FLOW_GO_TO_HOMEPAGE_BUTTON</Trans>}
        href="/"
        sx={{ mt: '4px' }}
        onClick={onClickGoToHomepage}
      />
    </>
  )
}
